// extracted by mini-css-extract-plugin
export var githubLogo = "project-module--githubLogo--15hNQ";
export var imageWrapper = "project-module--imageWrapper--2JMtL";
export var wrapper = "project-module--wrapper--52Py1";
export var linkText = "project-module--linkText--1kBR2";
export var description = "project-module--description--2V9T3";